// extracted by mini-css-extract-plugin
export default {"placeHolderShimmer":"YearsMonths_placeHolderShimmer__+-UBj"};